export default __webpack_public_path__ + "static/media/outdoor_logo.f7e89fea.png";